<template>
    <section id="about" class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <h2>13 reasons why we could be friends<i class="fas fa-user-circle right-align"></i></h2>
                <ol>
                    <li class="stand-out">You enjoy learning about people and how to address their needs by means of technology,</li>
                    <li class="stand-out">
                        You agree that functionality is important, but
                        <span class="emphasis">usability should never be written off!</span>
                    </li>
                    <li>You were born in Bandung, Indonesia and/or love the city,</li>
                    <li>You concede that <em>"Indonesian food is the best!"</em> is a sound argument,</li>
                    <li>You are a faithful German football fanatic,</li>
                    <li>... as the name suggests, you understand that football is the one that you play with a ball on your feet,</li>
                    <li><em>Mia san mia</em> means a lot to you,</li>
                    <li>You constantly thank God for music,</li>
                    <li>You agree that The Beatles are the best ever!</li>
                    <li>Sherlock and Peaky Blinders top your favourite shows list,</li>
                    <li>You wish reading books is a paid job,</li>
                    <li>Not technically a Geordie, but won't mind being one,</li>
                    <li>... is the best number! Any other Michael Ballack fans out there?</li>
                </ol>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
h2 {
    color: $colour-blue-primary;
    margin-bottom: 2rem;
}

.fa-user-circle {
    &:hover {
        color: $colour-blue-light;
    }
}

ol {
    text-align: center;
    list-style: none;
    padding: 0;
}

li{
    font-size: 1rem;
    margin: 0.75rem 0;
    counter-increment: li;
    
    /* Create custom list numbering */
    &::before {
        content: counter(li);
        margin-right: 1rem;
        color: $colour-blue-primary;
        font-style: italic;
        font-size: 1rem;
        font-weight: 700;
        border-bottom: 1px solid $colour-blue-light;
    }

    /* For stand out lines */
    &.stand-out {
        font-size: 1.25rem;

        /* Points to emphasise */
        .emphasis {
            font-weight: 700;
            font-style: italic;
            color: $colour-blue-primary;
        }
    }
}
</style>
